import apiSDK from '@/services/apiSdk';
import { useMutation } from '@tanstack/react-query';

export default function useAssumeToken() {
    const mutationFn = async (userId: number) => {
        const { data } = await apiSDK.session.assumeToken({ userId });
        return data;
    };

    return useMutation({
        mutationFn,
    });
}
